import { useContext } from "react";
import { TitrationContext } from "./TitrationProvider";

export const useTitration = () => {
  return useContext(TitrationContext);
};
